// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight {
  color: #00a5cf;
  background: transparent;
}

:host ::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  border-color: #00a5cf;
  background: #00a5cf;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content.p-treenode-selectable:not(.p-highlight):hover {
  color: #004a61;
  background: transparent;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler {
  color: #798da9;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content .p-tree-toggler:enabled:hover {
  background: #e9ecef;
}

:host ::ng-deep .p-tree .p-tree-container .p-treenode .p-treenode-content.p-highlight .p-tree-toggler {
  color: #798da9;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
